import React from 'react';
import {
  ProgressBar,
  Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { PHASES } from '../../constants';

const getStepLabel = (phase, totalPhases) => {
  if (totalPhases === 1) {
    return "We're finding the right products for you.";
  }
  if (phase === PHASES.RESOLVING) {
    return `(1/${totalPhases}) We're finding the right products...`;
  }
  if (phase === PHASES.ESTIMATING) {
    return `(2/${totalPhases}) We're estimating the right quantities...`;
  }
  return 'Finished!';
};

export const IntentResolutionProgress = ({
  progress,
  phase = PHASES.RESOLVING,
  totalPhases = 1
}) => {
  const {
    itemCount,
    resolutionProgress
  } = progress;

  const progressValue = phase === PHASES.COMPLETE ? 100 : resolutionProgress;
  const status = progressValue === 100 ? 'success' : undefined;

  return (
    <div className="sui-w-full sui-flex sui-flex-col sui-gap-1">
      <Typography variant="body-lg" weight="bold">Hang Tight!</Typography>
      <Typography variant="body-base">
        {getStepLabel(phase, totalPhases)}
      </Typography>
      <div className="sui-pt-8">
        <ProgressBar
          key={phase}
          status={status}
          value={progressValue}
          startLabel={`${itemCount} items`}
          endLabel={`${progressValue}%`}
        />
      </div>
    </div>
  );
};

IntentResolutionProgress.propTypes = {
  progress: PropTypes.shape({
    itemCount: PropTypes.number,
    resolutionProgress: PropTypes.number
  }).isRequired,
  phase: PropTypes.oneOf(Object.values(PHASES)),
  totalPhases: PropTypes.number
};

IntentResolutionProgress.defaultProps = {
  phase: PHASES.RESOLVING,
  totalPhases: 1
};
